import React from 'react';

interface CameraIconProps {
    width?: number | string;
    height?: number | string;
    color?: string;
    className?: string;
    fill?: string;
}

const CameraIcon = ({
    width = 24,
    height = 24,
    color = "#ffffff",
    className = "",
    fill = "currentColor"

}: CameraIconProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            // fill="none"
            viewBox="0 0 24 24"
            width={width}
            height={height}
            stroke={color}
            strokeWidth="2"
            className={className}
            fill={fill}
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
            />
            <circle cx="12" cy="13" r="3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

export default CameraIcon;
